function addThousandSeparatorsToIntegerPart(str) {
  const parts = String(str).split(",")
  parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
  return parts.join(",")
}

export function currencyFormatDE(num, simbol, decimals = 2) {
  const s = num.toFixed(decimals).replace(".", ",")
  return addThousandSeparatorsToIntegerPart(s) + " " + simbol
}

export function currencyFormatWithoutSimbol(num, decimals = 2) {
  const s = parseFloat(String(num).replace(",", "."))
    .toFixed(decimals)
    .replace(".", ",")
  return addThousandSeparatorsToIntegerPart(s)
}

export function currencyFormatToNumber(num, decimals = 2) {
  return parseFloat(num.toString().replace(".", "").replace(",", "."))
    .toFixed(decimals)
    .replace(".", ",")
}

export function currencyFormatToConcept(num, decimals = 2) {
  const s = parseFloat(num).toFixed(decimals).replace(".", ",")
  return addThousandSeparatorsToIntegerPart(s)
}

export function currencyFormatToFloat(num, decimals = 2) {
  return parseFloat(
    num.toString().replaceAll(".", "").replaceAll(",", "."),
  ).toFixed(decimals)
}
